var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"row content-center",class:_vm.typeColor,domProps:{"textContent":_vm._s(_vm.types[_vm.type])}})}
var staticRenderFns = []

export { render, staticRenderFns }